import React from "react";
import IncentiveSheet from "./BenchModule/IncentiveSheet";
import MasterSheet from "./BenchModule/MasterSheet";
import TableIncentive from "./TableIncentive";
import IncentiveModuleLayout from "./IncentiveModuleLayout";

const BenchModule = () => {
  const benchModuleTabs = [
    {
      title: "Master Sheet",
      page: <MasterSheet />,
      type: "main",
    },
    {
      title: "Incentive Sheet",
      page: <IncentiveSheet />,
      type: "main",
    },
  ];

  return (
    <IncentiveModuleLayout
      moduleName="Bench"
      initialCards={[]}
      tabs={benchModuleTabs}
      tabId="bench-module"
    />
  );
};

export default BenchModule;
